export default __webpack_public_path__ + "static/media/qr.727c9e03.jpg";